<template>
    <b-modal
        v-model="modal"
        modal-class="apprentice-default-modal internship-status-logs-modal"
        ok-only
        :ok-title="$t('common.close')"
        size="lg"
        title="Logs">
        <div class="internship-logs">
            <design-2021-apprentice-data-table
                class="internship-project-logs-table"
                :fields="fields"
                :custom-per-page="50"
                :items="logs">
                <template #cell(created_at)="data">
                    <div class="date">
                        {{
                            (data.item.updated_at !== null ? data.item.updated_at : data.item.created_at) | date_time_om
                        }}
                    </div>
                </template>

                <template #cell(properties.attributes.status)="data">
                    <div class="status">
                        <b-badge :variant="getStatusVariant(data.item.properties.attributes.status)">
                            {{ getStatustext(data.item.properties.attributes.status) }}
                        </b-badge>
                    </div>
                </template>
            </design-2021-apprentice-data-table>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-internship-status-logs-modal-component',
    data() {
        return {
            modal: false,
            fields: [
                {
                    key: 'created_at',
                    label: 'Datum',
                    sortable: true,
                },
                {
                    key: 'properties.attributes.status',
                    label: 'Status',
                    sortable: false,
                },
                {
                    key: 'causer.full_name',
                    label: this.$t('group.internship.user'),
                    sortable: false,
                },
                {
                    key: 'properties.attributes.internship_title',
                    label: this.$t('group.internship.internship_place'),
                    sortable: false,
                },
                {
                    key: 'properties.attributes.motivation',
                    label: this.$t('group.internship.motivation'),
                    sortable: false,
                },
                {
                    key: 'properties.attributes.feedback',
                    label: 'Feedback',
                    sortable: false,
                },
            ],
            logs: [],
        };
    },

    methods: {
        show(internshipProject) {
            this.logs = internshipProject.activities;
            this.modal = true;
        },

        getStatusVariant(status) {
            switch (status) {
                case 0:
                    return 'open';
                    break;

                case 1:
                    return 'submitted';
                    break;

                case 2:
                    return 'closed';
                    break;
            }
        },

        getStatustext(status) {
            switch (status) {
                case 0:
                    return this.$t('group.internship.reopened');
                    break;

                case 1:
                    return this.$t('group.internship.in_progress');
                    break;

                case 2:
                    return this.$t('group.internship.approved');
                    break;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.internship-project-logs-table ::v-deep {
    .search {
        display: none;
    }
}
</style>
